// services/endpoints.js - Single source of truth for all API endpoints

export const ENDPOINTS = {
  // Time Activity
  TIME_PRODUCTIVITY_TABLE: '/time-activity/productivity-table',
  TIME_MONTHLY_PRODUCTIVITY: '/time-activity/monthly-productivity',
  TIME_OVERSERVICE_COMPARISON: '/time-activity/overservice-comparison',
  TIME_CUSTOMER_FEE_SUMMARY: '/time-activity/customer-fee-summary',
  TIME_MAX_DATES: '/time-activity/max-dates',
  
  // Finance
  FINANCE_REVENUE_CHART: '/finance/revenue-chart-data',
  FINANCE_REVENUE_BY_MONTH: '/finance/revenue-by-month',
  FINANCE_DASHBOARD_SUMMARY: '/finance/dashboard-summary',
  FINANCE_CUSTOMER_BREAKDOWN: '/finance/customer-revenue-breakdown',
  FINANCE_CASH_ON_HAND: '/finance/cash-on-hand',
  FINANCE_AVERAGE_EXPENSES: '/finance/average-expenses',
  FINANCE_AR_DASHBOARD: '/finance/ar-dashboard',
  FINANCE_AMI_BREAKDOWN: '/finance/ami-breakdown-by-month',
  FINANCE_FINANCIAL_HEALTH: '/finance/financial-health-metrics',
  FINANCE_MAX_DATES: '/finance/max-dates',
  FINANCE_PROFIT_LOSS: '/finance/profit-and-loss-by-month',
  FINANCE_ADJUSTED_GROSS_INCOME: '/finance/adjusted-gross-income',
  FINANCE_DEBT_OUTSTANDING: '/finance/debt-outstanding',
  FINANCE_CUSTOMER_LTV: '/finance/customer-ltv',
  FINANCE_CUSTOMER_CHURN: '/finance/customer-churn-rate',

  // Playground
  PL_SCENARIO_DATA: '/pl-scenario/data',
  PL_LINE_ITEM_DETAILS: '/pl-scenario/line-item-details',

  // ============================================================================
  // P&L SCENARIOS
  // ============================================================================
  PL_SCENARIOS_LIST: '/pl-scenarios',
  PL_SCENARIOS_GET: (id) => `/pl-scenarios/${id}`,
  PL_SCENARIOS_CREATE: '/pl-scenarios',
  PL_SCENARIOS_UPDATE: (id) => `/pl-scenarios/${id}`,
  PL_SCENARIOS_DELETE: (id) => `/pl-scenarios/${id}`,
  PL_SCENARIOS_DUPLICATE: (id) => `/pl-scenarios/${id}/duplicate`,
  

  // Employee Rates
  EMPLOYEE_RATES_LIST: '/employee-rates',
  EMPLOYEE_RATES_GET: (id) => `/employee-rates/${id}`,
  EMPLOYEE_RATES_HISTORY: (id) => `/employee-rates/${id}/history`,
  EMPLOYEE_RATES_RATE_AT_DATE: (id) => `/employee-rates/${id}/rate-at-date`,
  EMPLOYEE_RATES_CREATE: '/employee-rates',
  EMPLOYEE_RATES_UPDATE: (id) => `/employee-rates/${id}`,
  EMPLOYEE_RATES_DELETE: (id) => `/employee-rates/${id}`,
  EMPLOYEE_RATES_SYNC: '/employee-rates/sync',
  EMPLOYEE_RATES_SUMMARY: '/employee-rates/analytics/summary',
  EMPLOYEE_RATES_RECENT_CHANGES: '/employee-rates/analytics/rate-changes',
  EMPLOYEE_RATES_BULK_UPDATE: '/employee-rates/bulk-update',
  EMPLOYEE_RATES_HEALTH: '/employee-rates/health',

  //SALES
  SALES_LEAD_METRICS: '/sales/lead-metrics',
  SALES_LEAD_SOURCE_BREAKDOWN: '/sales/lead-source-breakdown',
  SALES_LEADS_LIST: '/sales/leads-list',  // ← NEW ENDPOINT
  SALES_PIPELINE_BREAKDOWN: '/sales/pipeline-breakdown',
  
  //GA4 Analytics
  GA4_ACTIVE_USERS_BY_CHANNEL: '/ga4_analytics/active-users-by-channel',

  // GSC Analytics
  GSC_TOP_QUERIES: '/gsc_analytics/top-queries',
  GSC_TOP_PAGES: '/gsc_analytics/top-pages',

  // Cost & ROI Analytics
  COST_ROI_METRICS: '/cost_roi/metrics',

  // User Preferences
  USER_PREFERENCE: (pageId, preferenceKey) => `/user-preferences/${pageId}/${preferenceKey}`,
  USER_PREFERENCES_PAGE: (pageId) => `/user-preferences/${pageId}`,
  USER_PREFERENCES_ALL: '/user-preferences',
  USER_PREFERENCES_EXPORT: '/user-preferences/export/all',
  USER_PREFERENCES_HEALTH: '/user-preferences/health/check',

  // ============================================================================
  // NOTIFICATIONS - User Endpoints
  // ============================================================================
  NOTIFICATIONS_LIST: '/notifications/list',
  NOTIFICATIONS_UNREAD_COUNT: '/notifications/unread-count',
  NOTIFICATIONS_DETAILS: (id) => `/notifications/${id}/details`,
  NOTIFICATIONS_MARK_READ: (id) => `/notifications/${id}/mark-read`,
  NOTIFICATIONS_MARK_UNREAD: (id) => `/notifications/${id}/mark-unread`,
  NOTIFICATIONS_DISMISS: (id) => `/notifications/${id}/dismiss`,
  NOTIFICATIONS_MARK_ALL_READ: '/notifications/mark-all-read',
  
  // ============================================================================
  // NOTIFICATIONS - Admin Endpoints
  // ============================================================================
  NOTIFICATIONS_ADMIN_RULES: '/notifications/admin/rules',
  NOTIFICATIONS_ADMIN_RULE: (id) => `/notifications/admin/rules/${id}`,
  NOTIFICATIONS_ADMIN_TOGGLE: (id) => `/notifications/admin/rules/${id}/toggle`,
  NOTIFICATIONS_ADMIN_SCHEDULE: (id) => `/notifications/admin/rules/${id}/schedule`,
  NOTIFICATIONS_ADMIN_ROLES: (id) => `/notifications/admin/rules/${id}/roles`,
  NOTIFICATIONS_ADMIN_RUN_NOW: (id) => `/notifications/admin/rules/${id}/run-now`,
  NOTIFICATIONS_ADMIN_HISTORY: (id) => `/notifications/admin/rules/${id}/history`,
  
  // Health
  NOTIFICATIONS_HEALTH: '/notifications/health',
  
};